import { showSpectrumErrorToast } from "./showSpectrumErrorToast";

function defaultToast(message, options) {
  return showSpectrumErrorToast(message, options);
}

let toastImpl = defaultToast;

/** Allows tests or the provider to wrap toast behavior (e.g. analytics). */
export function registerAppToastImplementation(fn) {
  toastImpl = fn || defaultToast;
}

/** Imperative toast API usable from class components and non-React modules. */
export function showAppErrorToast(message, options) {
  return toastImpl(message, options);
}

/** Multiple independent API failures → multiple stacked Spectrum toasts. */
export function showAppErrorToasts(messages, options) {
  if (!Array.isArray(messages)) return;
  messages.filter(Boolean).forEach((msg) => toastImpl(msg, options));
}
